import React, {Component} from 'react';
import LoginModeBtn from "../LoginModeBtn";
import i18n from 'i18next'
import './index.css'

class LoginThirdBtn extends Component {
    constructor(props) {
        super(props);
        this.languageCont=React.createRef()
        this.state={
            lang : React.cookie.load("bby_lang") ? React.cookie.load("bby_lang") : window._bby_config.lang,
            languageShow : false,
            modeBtnShow: props.modeBtnShow ? {...props.modeBtnShow} : {
                dingdingShow:true,
                workWechatShow:true,
                qyWechatShow:true,
                qyzjWechatShow:true,
                SSOShow:false,
                feishuShow:true,
                wechatShow:true,
                LoginAccountPasswordShow: true,
                LoginCodeShow: true,
            },
            ...props.customLoginConfig
        }
    }
    languageChange = (event) =>{
        const s=event.target.parentNode.children;
        for(let i = 0; i <s.length; i++){
            s[i].classList.remove("select");
        }
        event.target.classList.add("select");
        const n = event.target.classList[0];
        React.cookie.save("bby_lang",n)
        i18n.changeLanguage(n);
        this.setState({lang:n})
    }
    languageShow = (event) =>{
        event.stopPropagation()
        const {languageShow} = this.state
        this.setState({languageShow:!languageShow})
    }
    componentDidMount() {
        document.addEventListener('click', this.hideAllMenu);
    }
    hideAllMenu = (event) =>{
        event.stopPropagation()
        const {languageShow} = this.state
        if(languageShow === true){
            this.setState({languageShow:false})
        }
    }
    render() {
        const {changeContModePage, isCorp, customLoginConfig} = this.props;
        const {languageShow, lang, modeBtnShow, register, hasAccountLogin, hasSSOLogin, language} = this.state;
        return (
            <div className="LoginThirdBtn">
                {(register || hasAccountLogin) && <LoginModeBtn isCorp={isCorp} customLoginConfig={customLoginConfig} modeBtnShow={modeBtnShow} changeContModePage={changeContModePage} />}
                <div className={(register && (window.data_config.mobileCodeLogin || window.data_config.emailCodeLogin) && hasAccountLogin && window.data_config.commonLogin) ? "codeAccountSwitch" : "codeAccountSwitch one"}>
                    {window.data_config.commonLogin &&
                    hasAccountLogin &&
                    <div className={`accountLoginBtn ${!modeBtnShow.LoginAccountPasswordShow ? "select" : ""}`} onClick={changeContModePage("LoginAccountPasswordShow")}>
                        {React.language('m.account.password.login')}
                    </div>}
                    {register && (window.data_config.mobileCodeLogin || window.data_config.emailCodeLogin) && <div onClick={changeContModePage("LoginCodeShow")} className={`loginCodeBtn ${!modeBtnShow.LoginCodeShow ? "select" : ""}`}>{React.language('m.code.login.seconds')}</div>}
                </div>
                {language && window.screen.width <= 1200 && <div ref={this.languageCont} className={"languageCont"}>
                    <div onClick={this.languageShow} className="languageTitle">
                        <span className={"titleItem" + (lang === "zh_cn" ? " select" : "")}>中文</span>/
                        <span className={"titleItem" + (lang === "zh_tw" ? " select" : "")}>繁体</span>/
                        <span className={"titleItem" + (lang === "en_us" ? " select" : "")}>EN</span>
                    </div>
                    {languageShow && <ul onClick={this.languageChange} className="languageList">
                        <li className={lang === "zh_cn" ? "zh_cn select" : "zh_cn"}>简体中文</li>
                        <li className={lang === "zh_tw" ? "zh_tw select" : "zh_tw"}>繁體中文</li>
                        <li className={lang === "en_us" ? "en_us select" : "en_us"}>English</li>
                    </ul>}
                </div>}
            </div>
        );
    }
}

export default LoginThirdBtn;